import { render } from "./PaymentGivingForm2.vue?vue&type=template&id=099bd8a4&scoped=true"
import script from "./PaymentGivingForm2.vue?vue&type=script&lang=js"
export * from "./PaymentGivingForm2.vue?vue&type=script&lang=js"

import "./PaymentGivingForm2.vue?vue&type=style&index=0&id=099bd8a4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-099bd8a4"]])

export default __exports__